import React from 'react';
import { cx } from '@emotion/css';
import { photoTableImg } from './quizApp.style';
import MathParser from './MathParser';
import { isAnswerCorrect } from '../utils/answerUtils';

function CorrectAnswers(props) {
  const selectedAnswer = props.selectedanswer || 'Not answered';
  const correctAnswer = props.correctanswer?.trim() || '';
  const alternateAnswers = Array.isArray(props.alternateanswers) ? props.alternateanswers : [];
  
  const isCorrect = isAnswerCorrect(
    selectedAnswer,
    [correctAnswer, ...alternateAnswers],
    props.ignorecases,
    props.category
  );

  // Convert block math to inline math with displaystyle to prevent table overlap issues
  const formatForTable = (text) => {
    if (typeof text !== 'string') return text;
    return text.replace(/\$\$(.*?)\$\$/g, '$\\displaystyle $1$');
  };

  const tdStyle = { padding: '15px 10px', verticalAlign: 'middle', textAlign: 'center', borderBottom: '1px solid #eee' };

  const formatAnswer = (ans) => {
    if (ans === 'Not answered' || !ans) return ans;
    const ansStr = String(ans);
    const stripped = ansStr.replace(/^\$+|\$+$/g, '');
    if (stripped.includes('\\') || stripped.includes('^') || stripped.includes('_') || (ansStr.startsWith('$') && ansStr.endsWith('$'))) {
      return `$\\displaystyle ${stripped}$`;
    }
    return ansStr;
  };

  return (
    <tr>
      <td style={{ ...tdStyle, textAlign: 'left' }}>
        {props.eventtype === 'ImagewithTextField' ? (
          <img className={cx(photoTableImg)} src={props.question} alt="Question" />
        ) : (
          <MathParser text={formatForTable(props.question)} />
        )}
      </td>
      <td style={tdStyle}>
        <MathParser text={formatAnswer(correctAnswer)} />
      </td>
      <td style={tdStyle}>
        <MathParser text={formatAnswer(selectedAnswer)} />
      </td>
      <td style={tdStyle}>
        {isCorrect ? (
          <img height="40" width="40" src="../assets/pass.png" alt="Pass" />
        ) : (
          <img height="40" width="40" src="../assets/fail.png" alt="Fail" />
        )}
      </td>
      <td style={tdStyle}>
        <button
          onClick={() => {
            props.selected?.(props.questionid);
          }}
          style={{ background: 'none', border: 'none', cursor: 'pointer' }}
        >
          <img src={require('../assets/images/email.png').default} alt="Email" />
        </button>
      </td>
    </tr>
  );
}

export default CorrectAnswers;